<span class="text-low" (click)="moreChange.emit(!more)">
  <span *ngIf="!more">meer </span><div class="collapse-button" [ngClass]="{'is-collapsed': more}"><i class="fas fa-angle-double-right"></i></div><span *ngIf="more"> minder</span>
</span>